import { SSOAttributeVisibilityRole } from '../types';

export const SSO_ATTRIBUTE_VISIBILITY_OPTIONS: Array<{
  value: SSOAttributeVisibilityRole;
  label: string;
  description: string;
}> = [
  {
    value: 'all',
    label: 'All application creators',
    description: 'Visible to app admins, owners, delegates, and SSO admins',
  },
  {
    value: 'app_admin',
    label: 'App admins',
    description: 'Visible when app admins create or configure applications',
  },
  {
    value: 'user',
    label: 'Application owners',
    description: 'Visible to users who own applications',
  },
  {
    value: 'delegate',
    label: 'Delegates',
    description: 'Visible to delegated administrators',
  },
  {
    value: 'sso_admin',
    label: 'SSO admins only',
    description: 'Hidden from app admins and owners during application setup',
  },
];

export function getVisibilityRoleLabels(roles: string[] | undefined): string[] {
  if (!roles?.length) return [];
  if (roles.includes('all')) return ['All creators'];
  return roles
    .map((r) => SSO_ATTRIBUTE_VISIBILITY_OPTIONS.find((o) => o.value === r)?.label || r)
    .filter((label) => label.length > 0);
}

export function formatVisibilityRoles(roles: string[] | undefined): string {
  const labels = getVisibilityRoleLabels(roles);
  return labels.length ? labels.join(', ') : '—';
}
